// extracted by mini-css-extract-plugin
module.exports = {"container":"KYX_container__1tgb7","link":"KYX_link__3d38J"};